import Stack from "@mui/material/Stack";
import { Table, TableBody } from "@mui/material";
import { useMemo } from "react";
import { BudgetDetailsSectionWrapper } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/common/BudgetDetailsSectionWrapper";
import { budgetDetailsByIdDataSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdDataSelector";
import { useAppSelector } from "@/store/hooks";
import { GeneralContentDetailsTableRow } from "@/components/pages/common/resource-details/components/content/general-content/components/details/GeneralContentDetailsTableRow";
import { TypographyWithCopy } from "@/components/common/TypographyWithCopy";
import { getBudgetDetailsRows } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/details-section/getBudgetDetailsRows";
import { budgetDetailsIntegrationSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsIntegrationSelector";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { BudgetDetailsRowSkeletonWrapper } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/details-section/BudgetDetailsRowSkeletonWrapper";

export const BudgetDetailsDetailsSection = () => {
  const budget = useAppSelector(budgetDetailsByIdDataSelector);
  const budgetIntegration = useAppSelector(budgetDetailsIntegrationSelector);
  const quarterStartMonth = useAppSelector(
    organisationQuarterStartMonthSelector,
  );

  const details = useMemo(() => {
    return getBudgetDetailsRows(budget, budgetIntegration, quarterStartMonth);
  }, [budget, budgetIntegration, quarterStartMonth]);

  return (
    <BudgetDetailsSectionWrapper title="Details">
      <Stack width="100%" p={1.5}>
        <Table sx={{ tableLayout: "fixed" }}>
          <TableBody>
            {details.map((detail, i) => {
              return (
                <GeneralContentDetailsTableRow
                  key={detail.title}
                  label={detail.title}
                  highlight={i % 2 === 0}
                >
                  <BudgetDetailsRowSkeletonWrapper>
                    {typeof detail.value === "string" ? (
                      <TypographyWithCopy
                        value={detail.value}
                        variant="body2"
                      />
                    ) : (
                      detail.value
                    )}
                  </BudgetDetailsRowSkeletonWrapper>
                </GeneralContentDetailsTableRow>
              );
            })}
          </TableBody>
        </Table>
      </Stack>
    </BudgetDetailsSectionWrapper>
  );
};
